(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-and-brochure"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sliderWrapper = document.querySelector('.collection-slider__wrapper.is-slider');

    if (sliderWrapper) {
      const glide = sliderWrapper.querySelector('.glide');

      if (glide) {
        new Glide(glide, {
          type: 'carousel',
          perView: 3,
          gap: 20,
          breakpoints: {
            1024: { perView: 2 },
            768: { perView: 1 },
          },
        }).mount();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sliderWrapper = document.querySelector('.collection-slider__wrapper.is-slider');

    if (sliderWrapper) {
      const glide = sliderWrapper.querySelector('.glide');

      if (glide) {
        new Glide(glide, {
          type: 'carousel',
          perView: 3,
          gap: 20,
          breakpoints: {
            1024: { perView: 2 },
            768: { perView: 1 },
          },
        }).mount();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.querySelector('.search-input');

    if (searchInput) {
      searchInput.addEventListener('blur', function () {
        document.querySelector('predictive-search-component').classList.remove('predictive-search--expanded');
      });
    }
  });

  document.querySelectorAll('#MyCustomFacetForm input, #MyCustomFacetForm select').forEach((el) => {
    el.addEventListener('change', function () {
      // Build URL with filters
      const formData = new FormData(document.getElementById('MyCustomFacetForm'));
      const searchParams = new URLSearchParams(formData).toString();

      fetch(window.location.pathname + '?' + searchParams)
        .then((res) => res.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newProducts = doc.querySelector('#MyCustomProductGrid').innerHTML;
          document.querySelector('#MyCustomProductGrid').innerHTML = newProducts;
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sliderWrapper = document.querySelector('#product-slider');

    if (sliderWrapper) {
      console.log(sliderWrapper);

      const glide = sliderWrapper.querySelector('.glide');

      if (glide) {
        console.log(glide);
        new Glide(glide, {
          type: 'carousel',
          perView: 3,
          gap: 20,
          breakpoints: {
            1024: { perView: 2 },
            768: { perView: 1 },
          },
        }).mount();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rental-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const grid = document.querySelector('.product-grid');
    const customCard1 = document.querySelector('.product-card.custom-card-1');
    const customCard2 = document.querySelector('.product-card.custom-card-2');

    if (grid && customCard1 && customCard2) {
      const allCards = Array.from(grid.querySelectorAll('.product-card'));

      grid.removeChild(customCard1);
      grid.removeChild(customCard2);

      const updatedCards = Array.from(grid.querySelectorAll('.product-card'));

      if (updatedCards.length >= 3) {
        grid.insertBefore(customCard1, updatedCards[3]);
      } else {
        grid.appendChild(customCard1);
      }

      const newCards = Array.from(grid.querySelectorAll('.product-card'));

      if (newCards.length >= 4) {
        grid.insertBefore(customCard2, newCards[4]);
      } else {
        grid.appendChild(customCard2);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-to-top"] && !Shopify.designMode) return;
  try {
    
  const scrollToTopBtn = document.getElementById('scrollToTopBtn');

  window.addEventListener('scroll', () => {
    if (window.scrollY > 300) {
      scrollToTopBtn.classList.add('show');
    } else {
      scrollToTopBtn.classList.remove('show');
    }
  });

  scrollToTopBtn.addEventListener("click", (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["who-we-are"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.tab-buttons button');
    const panes = document.querySelectorAll('.tab-pane');

    buttons.forEach((button) => {
      button.addEventListener('click', function () {
        const tabId = this.getAttribute('data-tab');

        panes.forEach((pane) => (pane.style.display = 'none'));
        document.getElementById(tabId).style.display = 'block';

        buttons.forEach((btn) => btn.classList.remove('active'));
        this.classList.add('active');
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    new Glide('.tabs-slider-right', { type: 'carousel', perView: 1 }).mount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-us"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".image-text-block").forEach(function (container) {
    const text = container.querySelector(".why_us_more_content");
    const button = container.querySelector(".why_us_more_btn");

    button.addEventListener("click", function (event) {
      event.preventDefault();
      text.classList.toggle("active");
      button.querySelector("svg").classList.toggle("active");
      if (text.classList.contains("active")) {
        button.querySelector("span").textContent = "Read Less";
      } else {
        button.querySelector("span").textContent = "Read More";
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
